import { useState } from "react";
import FilePreviewModal from "./FilePreviewModal";
import { getFileName, isStoredFileReference } from "../utils/fileStorage";

function renderLegacyFile(file) {
  const isImage =
    file.type?.startsWith("image") ||
    /\.(png|jpe?g|gif|webp)$/i.test(file.name || "");

  const fileUrl =
    typeof file.content === "string"
      ? file.content.startsWith("data:") || file.content.startsWith("http")
        ? file.content
        : file.type
          ? `data:${file.type};base64,${file.content}`
          : null
      : file.url || null;

  return (
    <div>
      {isImage && fileUrl && (
        <img
          src={fileUrl}
          alt={file.name}
          loading="lazy"
          style={{
            maxWidth: 220,
            display: "block",
            marginBottom: 6,
            border: "1px solid #ccc",
            borderRadius: 4,
          }}
        />
      )}

      {fileUrl && (
        <a
          href={fileUrl}
          download={file.name}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1f9003ff" }}
        >
          {file.name || "Uploaded file"}
        </a>
      )}
    </div>
  );
}

export default function FileAnswerView({ value, shareToken }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const files = Array.isArray(value) ? value : [value];

  return (
    <>
      {files.map((file, index) => {
        if (!file) {
          return null;
        }

        if (typeof file === "object" && isStoredFileReference(file)) {
          return (
            <div key={`${getFileName(file)}-${index}`}>
              <span
                onClick={() => {
                  setSelectedFile(file);
                  setPreviewOpen(true);
                }}
                style={{
                  color: "#1f9003ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {getFileName(file)}
              </span>
            </div>
          );
        }

        if (typeof file === "object" && file.path) {
          return (
            <div key={`${getFileName(file)}-${index}`}>
              <span
                onClick={() => {
                  setSelectedFile(file);
                  setPreviewOpen(true);
                }}
                style={{
                  color: "#1f9003ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {file.file?.name || file.name || getFileName(file)}
              </span>
            </div>
          );
        }

        if (typeof file === "string" && file.startsWith("s3://")) {
          return (
            <div key={`${file}-${index}`}>
              <span
                onClick={() => {
                  setSelectedFile({ path: file });
                  setPreviewOpen(true);
                }}
                style={{
                  color: "#1f9003ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {getFileName(file)}
              </span>
            </div>
          );
        }

        if (typeof file === "object" && typeof file.content === "string" && file.content.startsWith("blob:")) {
          const name = file.file?.name || file.name || "Uploaded file";
          return (
            <div key={`${name}-${index}`}>
              <span style={{ color: "#1f9003ff" }}>{name}</span>
            </div>
          );
        }

        if (typeof file === "object") {
          return <div key={`${getFileName(file)}-${index}`}>{renderLegacyFile(file)}</div>;
        }

        return <div key={`${file}-${index}`}>{String(file)}</div>;
      })}

      <FilePreviewModal
        file={selectedFile}
        opened={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setSelectedFile(null);
        }}
        shareToken={shareToken}
      />
    </>
  );
}
